import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

export default function SimpleBackdrop( {open}) {
    return (
        <div>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={open}
            >
                <Skeleton
                    sx={{ bgcolor: 'grey.900' }}
                    variant="rectangular"
                    width={'100%'}
                    height={"100%"}
                />
                <div style={{marginTop : 60}}>
                    <Box sx={{ position:"absolute", top: "50%", left: "50%" }}>
                        <CircularProgress color="inherit" />
                    </Box>
                </div>
            </Backdrop>
        </div>
    );
}